import type {
    LaboratoryServicePurchasePriceUpdateParams,
    LaboratoryServicePurchasePriceCreationParams,
} from 'chaika-frontend-types/frontend-cms';

import { AbstractPriceService as CommonPriceService } from '@store/models/Price/AbstractPriceService';
import { PriceApi } from '@api/PriceApi';
import { removeUndefinedKeys } from '@utils/removeUndefinedKeys';

class PriceService extends CommonPriceService {
    public async createLaboratoryPurchasePrice(params: LaboratoryServicePurchasePriceCreationParams): Promise<void> {
        const paramsWithoutEmpty = removeUndefinedKeys(params);
        try {
            await PriceApi.createPurchasePrice({
                ...paramsWithoutEmpty,
                serviceId: paramsWithoutEmpty.serviceId,
                laboratoryId: paramsWithoutEmpty.laboratoryId,
            });
            this.priceStore.purchasePriceList.add([{ ...paramsWithoutEmpty, createdAt: new Date().toISOString() }]);
        } catch (e: any) {
            console.error(`Error: ${e?.message ?? e}`);
        }
    }

    public async updateLaboratoryPurchasePrice(params: LaboratoryServicePurchasePriceUpdateParams): Promise<void> {
        const paramsWithoutEmpty = removeUndefinedKeys(params);
        try {
            await PriceApi.updatePurchasePrice(paramsWithoutEmpty.id, {
                ...paramsWithoutEmpty,
            });
            this.priceStore.purchasePriceList.update(paramsWithoutEmpty.id, paramsWithoutEmpty);
        } catch (e: any) {
            console.error(`Error: ${e?.message ?? e}`);
        }
    }
}

export const priceService = new PriceService();
